import React, { useEffect, useRef } from 'react';

import { MondialRelayOptions, WidgetProps } from './types';
import { env } from 'settings/env';

import './widget.scss';

export default function Widget({
  postalCode,
  city,
  currentSelected,
  onSelect,
}: WidgetProps): JSX.Element {
  const widget = useRef<HTMLDivElement>(null);
  const mondialRelayBrand = env.ENV_MONDIAL_RELAY_CLIENT_CODE;

  useEffect(() => {
    if (!widget.current) return;

    if (!mondialRelayBrand) {
      console.warn('Missing mondial relay configuration');
    }

    const el = widget.current;
    const jQueryFunction = window['jQuery'];
    const $widgetContainer = jQueryFunction(el) || undefined;
    const options: MondialRelayOptions = {
      Target: '#mondialRelayTarget',
      Brand: mondialRelayBrand || '',
      Country: 'FR',
      Responsive: true,
      PostCode: currentSelected?.CP || postalCode || undefined,
      City: currentSelected?.Ville || city || undefined,
      OnParcelShopSelected: data => onSelect(data),
      AutoSelect: currentSelected
        ? `${currentSelected.Pays}-${currentSelected.ID}`
        : undefined,
    };

    $widgetContainer.MR_ParcelShopPicker(options);
  }, []);

  return (
    <>
      <input type={'hidden'} id="mondialRelayTarget" />
      <div ref={widget} id="mondialRelayWidget" />
    </>
  );
}
